import { render, staticRenderFns } from "./WorkflowForm.vue?vue&type=template&id=742b7ec2&scoped=true&"
import script from "./WorkflowForm.vue?vue&type=script&lang=js&"
export * from "./WorkflowForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowForm.vue?vue&type=style&index=0&id=742b7ec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742b7ec2",
  null
  
)

export default component.exports